/* eslint-disable @typescript-eslint/no-explicit-any */
import { requestHandler } from "common/utils/utils"
import { useCallback, useState } from "react"

const useModalAndCreate = () => {
  const [showCreateModal, setShowCreateModal] = useState<Record<string, any>>({
    status: false,
    data: null,
  })

  const handleOpenCreateModal = useCallback(
    (data: $TSMigrationFixMe) => {
      setShowCreateModal({
        status: !showCreateModal.status,
        data: data || null,
      })
    },
    [setShowCreateModal, showCreateModal.status]
  )

  const handleCloseCreateModal = () => {
    setShowCreateModal({
      status: false,
      data: null,
    })
  }

  const handleCreate = async (
    values: $TSMigrationFixMe,
    createCallback: $TSMigrationFixMe,
    config: $TSMigrationFixMe
  ) => {
    requestHandler(
      values,
      createCallback,
      config?.onSuccessCreate,
      config?.onSuccessCreateMessage,
      config?.onFailMessage,
      config?.onPostFailure,
      config?.onPostRequest
    )
  }
  return {
    handleCreate,
    handleOpenCreateModal,
    showCreateModal,
    handleCloseCreateModal,
  }
}

export default useModalAndCreate
